import { Box, Button, Checkbox, TextField, Typography, useMediaQuery } from '@mui/material';
import './VideoCss.css';
import { useState } from 'react';
import BonPlan from "../images/Fond_bonPlan.jpg";
import HoplaTheme from "../theme";
import SearchInput from '../components/SearchInput';
import Faq from '../components/Faq';
import { useHistory } from 'react-router';
import { sendContact } from '../services/contactService';
import { showMessage } from '../services/popupService';

export const ContactPage: React.FC = () => {
  const [client, setClient] = useState(true);
  const isMd = useMediaQuery(HoplaTheme.breakpoints.up("md"));
  const size = isMd ? '75%' : '90%';

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const [isChecked, setIsChecked] = useState(false);

  const [search, setSearch] = useState('');
  const history = useHistory();

  const handleSend = async () => {
    await sendContact(firstName, lastName, phone, email, message, !client);
    showMessage('Votre message a bien été envoyé.');
  };

  return (
    <>
      <Box sx={{ height: 140, backgroundColor: '#104f5c', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Typography variant='h5' fontWeight='bold' color='white' align='center'>
          Contactez-nous !
        </Typography>
      </Box>


      <Box sx={{
        backgroundImage: `url(${BonPlan})`,
        height: 'auto',
        flexDirection: 'column',
        width: '100%',
        backgroundRepeat: "no-repeat", backgroundSize: 'cover',
        display: 'flex',
        alignItems: 'center', justifyContent: 'center'
      }}>

        <Typography style={{ marginTop: '50px' }} fontWeight='bold' fontSize='clamp(1.3rem, 1.2vmax, 1.5vmax)'
          variant='h5' color='#ff6100' align='center'>
          Vous êtes ?
        </Typography>

        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          gap={6}
          mt={3}
        >
          <Button
            variant="contained"
            onClick={() => setClient(true)}
            sx={{
              backgroundColor: !client ? '#c4c4c4' : '#8a6acf',
              borderRadius: "12px",
              boxShadow: client ? 3 : 0,
              padding: "6px 18px",
              minWidth: "120px",
              textTransform: "none",
              '&:hover': {
                backgroundColor: !client ? '#c4c4c4' : '#8a6acf'
              }
            }}
          >
            <Typography variant="button" fontSize={14} align="center" textTransform="none">
              Client
            </Typography>
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={() => setClient(false)}
            sx={{
              backgroundColor: client ? '#c4c4c4' : '#8a6acf',
              borderRadius: "12px",
              boxShadow: client ? 0 : 3,
              padding: "6px 18px",
              minWidth: "120px",
              textTransform: "none",
              '&:hover': {
                backgroundColor: client ? '#c4c4c4' : '#8a6acf'
              }
            }}
          >
            <Typography variant="button" align="center" fontSize={14} textTransform="none">
              Coach
            </Typography>
          </Button>
        </Box>


        <Typography style={{
          marginTop: '50px', marginBottom: '60px'
        }} fontWeight='bold' fontSize='3vmax' color='black' align='center'>
          Option 1 : Demande d'informations
        </Typography>

        <Box
          component="form"
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "100%",
            maxWidth: size,
            margin: "auto",
          }}
        >
          <Box display="flex" gap={2}>
            <TextField fullWidth placeholder="Nom*" variant="filled" size="small"
              onChange={(e) => setLastName(e.target.value!)}
              inputProps={{ maxLength: 100, sx: { padding: '12px', fontSize: 'clamp(1rem, 1.8vmax,1.3vmax)', '::placeholder': { color: '#4e4f4f', opacity: 1 } } }}
              sx={{
                padding: '0px',

                height: '100%',
                color: '#4e4f4f',
                backgroundColor: '#afc9c9',
                borderRadius: '5px', "& .MuiFilledInput-root": {
                  backgroundColor: "#afc9c9",
                  borderRadius: "5px",
                  boxShadow: "none",
                  "&::before, &::after": { display: "none" },
                }
              }} />
            <TextField fullWidth placeholder="Prénom*" variant="filled"
              onChange={(e) => setFirstName(e.target.value!)}
              inputProps={{ maxLength: 100, sx: { padding: '12px', fontSize: 'clamp(1rem, 1.8vmax,1.3vmax)', '::placeholder': { color: '#4e4f4f', opacity: 1 } } }}
              sx={{
                backgroundColor: '#afc9c9',
                height: '100%',
                borderRadius: '5px', "& .MuiFilledInput-root": {
                  backgroundColor: "#afc9c9",
                  borderRadius: "5px",
                  boxShadow: "none",
                  "&::before, &::after": { display: "none" },
                }
              }} />
          </Box>

          <Box display="flex" gap={2}>
            <TextField fullWidth placeholder="Numéro de téléphone*" variant="filled"
              onChange={(e) => setPhone(e.target.value!)}
              inputProps={{ maxLength: 100, sx: { padding: '12px', fontSize: 'clamp(1rem, 1.8vmax,1.3vmax)', '::placeholder': { color: '#4e4f4f', opacity: 1 } } }}
              sx={{
                backgroundColor: '#afc9c9',
                height: '100%',
                borderRadius: '5px', "& .MuiFilledInput-root": {
                  backgroundColor: "#afc9c9",
                  borderRadius: "5px",
                  boxShadow: "none",
                  "&::before, &::after": { display: "none" },
                }
              }} />
            <TextField fullWidth placeholder="Adresse e-mail (facultatif)" variant="filled"
              onChange={(e) => setEmail(e.target.value!)}
              inputProps={{ maxLength: 100, sx: { padding: '12px', fontSize: 'clamp(1rem, 1.8vmax,1.3vmax)', '::placeholder': { color: '#4e4f4f', opacity: 1 } } }}
              sx={{
                backgroundColor: '#afc9c9',
                height: '100%',
                borderRadius: '5px', "& .MuiFilledInput-root": {
                  backgroundColor: "#afc9c9",
                  borderRadius: "5px",
                  boxShadow: "none",
                  "&::before, &::after": { display: "none" },
                }
              }} />
          </Box>

          <TextField
            fullWidth
            onChange={(e) => setMessage(e.target.value!)}
            placeholder="Vos questions (facultatif)"
            variant="filled"
            inputProps={{ maxLength: 500, sx: { padding: '0px', fontSize: 'clamp(1rem, 1.8vmax,1.3vmax)', '::placeholder': { color: '#4e4f4f', opacity: 1 } } }}
            multiline
            sx={{
              backgroundColor: '#afc9c9',
              height: '100%',
              borderRadius: '5px', "& .MuiFilledInput-root": {
                backgroundColor: "#afc9c9",
                borderRadius: "5px",
                boxShadow: "none",
                "&::before, &::after": { display: "none" },
              }
            }}
            rows={5}
          />
        </Box>

        <Box display="flex" alignItems="center" width={size}>
          <Checkbox checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)} />
          <Typography fontSize='clamp(1rem, 1.3vmax, 1.3vmax)'>
            J'accepte que les données saisies soient collectées et conservées
          </Typography>
        </Box>


        <Button
          variant="contained"
          color="secondary"
          disabled={!(firstName && lastName && phone && isChecked)}
          onClick={() => handleSend()}
          sx={{
            mt: 4,
            mb: 5,
            backgroundColor: '#8a6acf',
            borderRadius: "12px",
            padding: "4px 18px",
            minWidth: "120px",
            textTransform: "none",
            '&:hover': {
              backgroundColor: '#8a6acf'
            }
          }}
        >
          <Typography variant="button" sx={{
            padding: '0px 15px'
          }} align="center" fontSize='clamp(1rem, 1.8vmax,1.6vmax)' textTransform="none">
            Envoyer !
          </Typography>
        </Button>

        <Box sx={{ mb: 8, mt: 0, ml: 2, mr: 2 }}>
          <Typography
            align="center"
            textTransform="none"
            fontSize='clamp(1rem, 1.3vmax, 1.3vmax)'
            sx={{ lineHeight: 1.2, margin: "2px 0" }}
          >
            Rappel immédiat du Lundi au Jeudi 8h30 - 19h<br />
            et Vendredi et Samedi 9h30 - 18h<br />
            Vos données ne sont pas partagées !<br />
          </Typography>
        </Box>

      </Box>

      <Box sx={{ backgroundColor: '#afc9c9' }} display="flex"
        justifyContent="center"
        flexDirection='column'
        alignItems="center">
        <Typography style={{
          marginTop: '60px', marginBottom: '40px'
        }} fontWeight='bold' fontSize={26} color='black' align='center'>
          Option 2 : Numéro WhatsApp dédié
        </Typography>


        <Button
          variant="contained"
          onClick={() => window.open("https://wa.me/0616874995", "_blank")}
          sx={{
            backgroundColor: '#ff6100',
            borderRadius: "12px",
            boxShadow: client ? 3 : 0,
            padding: "5px 28px",
            minWidth: "120px",
            textTransform: "none",
            '&:hover': {
              backgroundColor: '#ff6100'
            }
          }}
        >
          <Typography fontSize={20} align="center" textTransform="none" fontWeight='600'>
            06 16 87 49 95
          </Typography>
        </Button>

        <Box sx={{ mb: 8, mt: 3, ml: 2, mr: 2 }}>
          <Typography
            align="center"
            textTransform="none"
            fontSize='clamp(1rem, 1.3vmax, 1.3vmax)'
            sx={{ lineHeight: 1.1, margin: "2px 0" }}
          >
            Lundi - Jeudi de 8h30 à 19h<br />
            Vendredi - Samedi de 9h30 à 18h<br />
            Ligne occupée ? Laissez un message, nous rappelons immédiatement !
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "100%",
          maxWidth: size,
          margin: "auto",
        }}>

        <Typography my={5} fontWeight='bold' variant='h5' color='#ff6100' align='center'
          fontSize='clamp(1.3rem, 1.2vmax, 1.5vmax)'>
          FAQ
        </Typography>

        <SearchInput onSearchChange={(e) => setSearch(e)} />

        <Typography color='black' variant='h6' fontWeight='bold' mt={2}>
          Questions les plus posées
        </Typography>

        <Faq pattern={search} />
      </Box>

      <Box mt={8} sx={{ backgroundColor: '#104f5c', display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
        <Button variant='contained' size='large' onClick={() => history.push('/reservation')}
          style={{
            textTransform: 'none',
            margin: '50px',
            maxHeight: '40px', minWidth: '240px',
            minHeight: '40px', borderRadius: 10, fontSize: '1.2em'
          }}>
          Réserver une séance
        </Button>
      </Box>
    </>
  );
};
